const BASE_URL = 'https://admin.mygo.co/api/hotel/';

const CREDENTIALS = {
  Login: 'XMLGOMAX',
  Password: 'RiNCua2$uK9WU3w1QRD2'
};

async function apiCall(endpoint, data = {}) {
  try {
    
    const payload = {
      Credential: CREDENTIALS,
      ...data
    };
    
    
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });


    const text = await response.text();

    if (!response.ok) {
      throw new Error(`API Error ${response.status}: ${text.substring(0, 200)}`);
    }

    let result;
    try {
      result = JSON.parse(text);
    } catch (e) {
      throw new Error(`Invalid JSON response: ${text.substring(0, 200)}`);
    }

    return result;
  } catch (error) {
    throw error;
  }
}

// ========================================
// STATIC DATA METHODS
// ========================================

export async function fetchCities() {
  const result = await apiCall('ListCity');
  return result.ListCity || [];
}

export async function fetchBoardings() {
  const result = await apiCall('ListBoarding');
  return result.ListBoarding || [];
}

export async function fetchTags() {
  const result = await apiCall('ListTag');
  return result.ListTag || [];
}

export async function fetchCurrencies() {
  const result = await apiCall('ListCurrency');
  return result.ListCurrency || [];
}

export async function fetchHotels(cityId = null) {
  const result = await apiCall('ListHotel', cityId ? { City: cityId } : {});
  return result.ListHotel || [];
}

export async function fetchHotelDetail(hotelId) {
  const result = await apiCall('HotelDetail', { Hotel: hotelId });
  return result.HotelDetail || null;
}

// ========================================
// SEARCH METHOD
// ========================================

export async function searchHotels(searchParams) {
  const bookingDetails = {
    CheckIn: searchParams.checkIn,
    CheckOut: searchParams.checkOut,
    City: searchParams.cityId,
    Currency: searchParams.currency || 'TND',
    Filters: {
      OnlyAvailable: searchParams.onlyAvailable !== false
    }
  };

  // ✅ ADD HOTEL FILTER IF PROVIDED (for DetailsPage optimization)
  if (searchParams.hotelId) {
    bookingDetails.Hotel = searchParams.hotelId;
  }

  const requestData = {
    SearchDetails: {
      BookingDetails: bookingDetails,
      Rooms: searchParams.rooms.map(room => ({
        Adult: room.adults,
        Child: room.children || []
      }))
    }
  };


  const result = await apiCall('HotelSearch', requestData);
  
  if (result.ErrorMessage && result.ErrorMessage.length > 0) {
  }
  
  
  return result.HotelSearch || [];
}

// ========================================
// BOOKING METHODS
// ========================================

export async function createBooking(bookingData, isPreBooking = false) {
  const requestData = {
    HotelBooking: {
      PreBooking: isPreBooking,
      Currency: bookingData.currency || 'TND',
      City: bookingData.cityId,
      Hotel: bookingData.hotelId,
      CheckIn: bookingData.checkIn,
      CheckOut: bookingData.checkOut,
      Option: bookingData.optionIds || [],
      Rooms: bookingData.rooms.map(room => ({
        Id: room.roomId,
        Boarding: room.boardingId,
        View: room.viewIds || [],
        Supplement: room.supplementIds || [],
        Pax: {
          Adult: room.adults || [],
          Child: room.children || []
        }
      }))
    }
  };

  return await apiCall('BookingCreation', requestData);
}

export async function cancelBooking(bookingId, preCancelled = false, currency = 'TND') {
  return await apiCall('BookingCancellation', {
    Booking: bookingId,
    PreCancelled: preCancelled,
    Currency: currency
  });
}

export async function fetchBookingList(filters = {}) {
  const requestData = {
    Currency: filters.currency || 'TND',
    Filters: {
      Booking: filters.bookingId,
      Hotel: filters.hotelId,
      FromDate: filters.fromDate,
      ToDate: filters.toDate,
      State: filters.state
    }
  };

  return await apiCall('BookingList', requestData);
}

// ========================================
// HELPER FUNCTIONS
// ========================================

export function formatDateForAPI(date) {
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  
  const d = typeof date === 'string' ? new Date(date) : date;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function parseAPIDate(dateString) {
  return new Date(dateString);
}

export function getCityNameById(cities, cityId) {
  const city = cities.find(c => c.Id === cityId);
  return city ? city.Name : '';
}

export function getBoardingNameById(boardings, boardingId) {
  const boarding = boardings.find(b => b.Id === boardingId);
  return boarding ? boarding.Name : '';
}